import { getButterGoatData } from './lessons/buttergoat/index';
import { getInsideData } from './lessons/inside';
import { getMuseData } from './lessons/muse/index';
import { getPeaksData } from './lessons/peaks/index';
import { getPokeData } from './lessons/poke/index';
import { getRiskyData } from './lessons/risky/index';
import { getSpideyData } from './lessons/spidey/index';
import { getSpookyData } from './lessons/spooky/index';
import { getWaltzData } from './lessons/waltz/index';
import { getZestData } from './lessons/zest/index';

const getLessonData = () => [
  getPeaksData(),
  getSpookyData(),
  getWaltzData(),
  getPokeData(),
  getZestData(),
  getRiskyData(),
  getMuseData(),
  getSpideyData(),
  getButterGoatData(),
  getInsideData()
];

export {
  getLessonData
};
